<template>
  <div>
    <v-card flat class="custom-card">
      <v-card-text>
        <v-layout v-for="form in formGroupingProduct" :key="form.label">
          <v-flex xs12 sm12 md12 class="pa-1">
            <div class="body-2 ma-2 grey--text">{{ form.type != null ? form.label : '' }}</div>
            <v-text-field
              v-if="form.type === 'text'"
              class="custom-text-field-owner"
              :label="form.label"
              :placeholder="form.label"
              solo
              flat
              v-model="product.grouping_product[form.id]"
            ></v-text-field>
            <v-select
              v-if="form.type === 'select'"
              :items="form.data"
              :label="form.label"
              solo
              item-text="label"
              item-value="value"
              flat
              class="custom-select"
              v-model="product.grouping_product[form.id]"
            ></v-select>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
    <br />
    <v-card flat class="custom-card">
      <v-card-text>
        <div class="title mb-2">List of Items</div>
        <v-layout row wrap>
          <v-flex v-for="form in formListOfItems" :key="form.label" xs4 sm4 md4 class="pa-1">
            <div class="body-2 ma-2 grey--text">{{ form.type != null ? form.label : '' }}</div>
            <v-text-field
              v-if="form.type === 'text'"
              class="custom-text-field-owner"
              :label="form.label"
              :placeholder="form.label"
              solo
              flat
              v-model="product.grouping_product[form.id]"
            ></v-text-field>
            <v-select
              v-if="form.type === 'select'"
              :items="form.data"
              :label="form.label"
              solo
              item-text="label"
              item-value="value"
              flat
              class="custom-select"
              v-model="product.grouping_product[form.id]"
            ></v-select>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
// import { mapActions } from "vuex";
export default {
  props: ["product"],
  name: "GroupingProduct",
  data() {
    return {
      itemsProduct: [
        { label: "Product 1", value: 0 },
        { label: "Product 2", value: 1 }
      ],
      itemsUOM: [{ label: "UOM 1", value: 0 }, { label: "UOM 2", value: 1 }],
      valid: true
    };
  },
  computed: {
    formGroupingProduct() {
      return [
        {
          type: "text",
          id: "name",
          label: "Name",
          isRequired: false
        },
        {
          type: "text",
          id: "description",
          label: "Description",
          isRequired: false
        }
      ];
    },
    formListOfItems() {
      return [
        {
          type: "select",
          id: "product_id",
          label: "Choose Product",
          data: this.itemsProduct,
          isRequired: false
        },
        {
          type: "select",
          id: "uom_id",
          label: "Choose UOM",
          data: this.itemsUOM,
          isRequired: false
        },
        {
          type: "text",
          id: "qty",
          label: "Qty",
          isRequired: false
        },
        {
          type: "text",
          id: "price",
          label: "Price",
          isRequired: false
        }
      ];
    }
  },
  watch: {},
  methods: {}
};
</script>

<style>
.custom-toolbar {
  border: 1px solid #cfcfcf !important;
  border-bottom: 0px !important;
}
.custom-toolbar .v-toolbar__content {
  height: 42px !important;
}
.custom-toolbar .v-toolbar__title {
  font-size: 18px !important;
}
</style>
